import { DropdownEntry } from '@toggle/design-system';
import classnames from 'classnames';
import React, { ReactNode } from 'react';

import { NavItem } from '../nav-item/NavItem';
import styles from './HeaderCategoryGroup.module.scss';

export type UnreadConversationType = {
  id: string;
  name: string;
  status?: string | null;
  tasks?: Array<{
    input?: string;
  }>;
};

export interface HeaderCategoryItem {
  label?: ReactNode;
  key: string;
  icon?: ReactNode;
  onClick: (item: HeaderCategoryItem, e?: React.MouseEvent) => void;
  dropdownItems?: DropdownEntry[][];
  customDropdownContent?: ReactNode | ((onClose: () => void) => ReactNode);
  pillStyle?: boolean;
  isAlfred?: boolean;
  showTooltip?: boolean;
  notification?: ReactNode;
  isProcessing?: boolean;
  isFinished?: boolean;
  isDashboardUpdatesEnabled?: boolean;
  unreadConversations?: UnreadConversationType[];
  onConversationClick?: (conversationId: string) => void;
}

export interface HeaderCategory {
  id?: string;
  title?: string;
  items: HeaderCategoryItem[];
}

interface HeaderCategoryGroupProps {
  activeKey?: string;
  active?: boolean;
  category: HeaderCategory;
  disabledKeys?: string[];
}

export const HeaderCategoryGroup = ({
  activeKey,
  category,
  disabledKeys,
}: HeaderCategoryGroupProps) => {
  return (
    <section className={styles.headerCategoryGroupRoot}>
      {category.title && (
        <h4 className={styles.headerCategoryTitle}>{category.title}</h4>
      )}
      <nav
        className={classnames(styles.headerItems, {
          [styles.options]: category.id === 'options',
        })}
      >
        {category.items.map(item => {
          return (
            <NavItem
              key={item.key}
              item={item}
              activeKey={activeKey}
              disabled={disabledKeys?.includes(item.key)}
            />
          );
        })}
      </nav>
    </section>
  );
};
